import { render, staticRenderFns } from "./courseList.vue?vue&type=template&id=dc87629c&scoped=true"
import script from "./courseList.vue?vue&type=script&lang=js"
export * from "./courseList.vue?vue&type=script&lang=js"
import style0 from "./courseList.vue?vue&type=style&index=0&id=dc87629c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc87629c",
  null
  
)

export default component.exports